import React, { Component } from 'react';

import ModalActionCreator from 'action_creators/modal';
import Summary from 'views/plugins/gift_certificates/summary/Summary';
import ContactModal from 'views/anyguide_bookings/modify_booking/ContactModal';

import './Confirmation.scss';

class Confirmation extends Component {
  openContactModal = (e) => {
    const { guestEmail } = this.props.checkoutFormData;

    const contactModal = (
      <ContactModal
        authenticityToken="test"
        bookingId="booking.id"
        guestEmail={guestEmail}
        guestId="tourist.id_hash"
        businessName="Warner Bros."
        originLocation="gift_certificates_confirmation"
      />
    );

    const modalSettings = {
      content: contactModal,
      triggeringElement: e.currentTarget,
    };

    ModalActionCreator.show(modalSettings);
  };

  renderRecipientText = () => {
    const {
      guestEmail,
      recipientEmail,
      recipientFirstName,
      recipientLastName,
    } = this.props.checkoutFormData;

    if (guestEmail !== recipientEmail) {
      return (
        <span>
          <br />
          <br />
          We also sent a confirmation email to your gift recipient,
          <span className="recipientName">
            &nbsp;{recipientFirstName} {recipientLastName}
          </span>
          , with all the details.
        </span>
      );
    }

    return null;
  };

  render() {
    return (
      <div className="confirmation checkoutForm">
        <div className="heading">Thanks! Your purchase is confirmed. </div>
        <div className="formBody">
          <div className="left">
            <p>
              We just sent an email to you with the purchase details.
              {this.renderRecipientText()}
            </p>

            <div className="messageLink">
              Questions?
              <br />
              <a onClick={this.openContactModal}>
                Send a message to Warner Brothers
              </a>
            </div>
          </div>
          <div className="right">
            <Summary checkoutData={this.props.checkoutData} />
          </div>
        </div>
      </div>
    );
  }
}

export default Confirmation;
